export default "__VITE_ASSET__Bz$f6R9a__"